import { render } from "./PrivacyPolicy.vue?vue&type=template&id=19db4f6c&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=19db4f6c&lang=less&scoped=true"

import exportComponent from "/Users/neal/Desktop/www/qingtv/qingtv-back-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19db4f6c"]])

export default __exports__